// @flow

import type { Bit } from '../types/Bit';

const convertToBit = (fieldValue: any): Bit => (Number(fieldValue) > 0 ? 1 : 0);

export default convertToBit;
